import { ConcernRequirement } from 'generated/api';
import { api } from 'careand-redux/api/ApiThunks';
import { createResettableSlice } from 'careand-redux/utils/makeResettable';
import { unwrap, unwrapApi } from 'careand-redux/utils/unwrap';

export interface ConcernRequirementsState {
  byId: Record<string, ConcernRequirement>;
  loaded: boolean;
}

const initialState: ConcernRequirementsState = {
  byId: {},
  loaded: false,
};

const slice = createResettableSlice({
  name: 'ConcernRequirements',
  initialState,
  reducers: {},
  extraReducers: (builder) =>
    builder
      .addCase(
        api.Appointments.getConcernRequirements.fulfilled,
        unwrap((state, requirements) => {
          state.byId = {};
          requirements.forEach((req) => {
            if (req.id) {
              state.byId[req.id] = req;
            }
          });
          state.loaded = true;
        }),
      )
      .addCase(
        api.Appointments.createConcernRequirement.fulfilled,
        unwrap((state, requirement) => {
          if (requirement?.id) {
            state.byId[requirement.id] = requirement;
          }
        }),
      )
      .addCase(
        api.Appointments.updateConcernRequirement.fulfilled,
        unwrap((state, requirement) => {
          if (requirement?.id) {
            state.byId[requirement.id] = requirement;
          }
        }),
      )
      .addCase(
        api.Appointments.deleteConcernRequirement.fulfilled,
        unwrapApi((state, _data, req) => {
          delete state.byId[req.id];
        }),
      ),
});

export const concernRequirementActions = slice.actions;
export default slice.reducer;
